import {cn} from '@/utils';
import React, {useEffect, useState} from 'react';
import {AnimatedCounter} from 'react-animated-counter';

const jackpotBg = require('../../assets/jackpot-fission.webp');
const textStyle =
  'bg-fission-text text-[34px] bg-clip-text text-transparent text-center';

interface ScrollingNumberProps {
  targetNumber: number;
  isScrolling?: boolean;
  duration?: number;
}

const ScrollingNumber: React.FC<ScrollingNumberProps> = ({
  targetNumber,
}: {
  targetNumber: number;
}) => {
  return (
    <div className={cn(textStyle, 'flex-1 text-center fissionBoard')}>
      <AnimatedCounter
        containerStyles={{
          marginLeft: 0,
        }}
        fontSize="36px"
        value={targetNumber}
        decimalPrecision={0}
      />
    </div>
  );
};

interface FissionBannerProps {
  amount?: number;
  currentCycle?: number;
}

const FissionBanner: React.FC<FissionBannerProps> = ({amount = 0}) => {
  const [displayAmount, setDisplayAmount] = useState(amount);

  const formatAmount = (num: number): string => {
    const maxValue = 999999999; // 9位数字的最大值
    const clampedNum = Math.min(num, maxValue);
    return clampedNum.toString().padStart(9, '0');
  };

  useEffect(() => {
    setDisplayAmount(amount);
  }, [amount]);

  const formattedAmount = formatAmount(displayAmount);
  return (
    <div className="relative w-full">
      <div className="relative w-full h-[115px] cursor-pointer">
        <div
          className="absolute bg-no-repeat h-[115px] top-0 left-1/2 transform -translate-x-1/2 w-[351px] z-10"
          style={{
            backgroundImage: `url('${jackpotBg}')`,
            backgroundSize: '100% 100%',
          }}>
          <div className="absolute bottom-[8px] h-[54px] left-[38px] w-[279px] flex items-center gap-px">
            <span className={cn(textStyle, 'w-[24px] flex-shrink-0')}>₹</span>
            {formattedAmount.split('').map((digit: string, index: number) => (
              <ScrollingNumber key={index} targetNumber={parseInt(digit, 10)} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FissionBanner;
